import { fetchKeywords } from '@/entities/insight';
import { useQuery } from '@tanstack/react-query';

export function useKeywords(params: Parameters<typeof fetchKeywords>[0], enabled?: boolean) {
  return useQuery({
    queryKey: [
      'keywords',
      params.queryId,
      params.startDate,
      params.endDate,
      JSON.stringify(params.publicFilter),
    ],
    queryFn: ({ signal }) => fetchKeywords(params, signal),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    enabled,
  });
}
